import React, { useState, useEffect } from "react";
import axios from 'axios';
import { baseurladdress } from "../baseurl";
import { useNavigate, NavLink } from "react-router-dom";
import './addstaff.css';

export default function AddStaff() {
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const Swal = require('sweetalert2')
    let navigate = useNavigate();

    // Form states
    const [cntry_name, setcntry_name] = useState([]);
    const [state_name, setstate_name] = useState([]);
    const [district_name, setdistrict_name] = useState([]);
    const [Staffname, setStaffname] = useState("");
    const [StaffCode, setStaffCode] = useState("");
    const [Staffdob, setStaffdob] = useState("");
    const [Staffgender, setStaffgender] = useState("");
    const [Staffmobile, setStaffmobile] = useState("");
    const [Staffphone, setStaffphone] = useState("");
    const [Staffemail, setStaffemail] = useState("");
    const [Staffbriefnote, setStaffbriefnote] = useState("");
    const [Stafffathername, setStafffathername] = useState("");
    const [Staffspousename, setStaffspousename] = useState("");
    const [Staffstreet, setStaffstreet] = useState("");
    const [Staffplace, setStaffplace] = useState("");
    const [Staffcountry, setStaffcountry] = useState("");
    const [Staffstate, setStaffstate] = useState("");
    const [Staffdistrict, setStaffdistrict] = useState("");
    const [Staffpincode, setStaffpincode] = useState("");
    const [Staffpassword, setStaffpassword] = useState("");
    const [Staffusername, setStaffusername] = useState("");
    const [ConfirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    // NEW: Cascading manager and area states
    const [regionalManagers, setRegionalManagers] = useState([]);
    const [selectedRegionalManager, setSelectedRegionalManager] = useState("");
    const [areaManagers, setAreaManagers] = useState([]);
    const [selectedAreaManager, setSelectedAreaManager] = useState("");
    const [availableAreas, setAvailableAreas] = useState([]);
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [showAreaModal, setShowAreaModal] = useState(false);
    const [primaryRegionId, setPrimaryRegionId] = useState(null);

    const handleSubmit = (event) => {
        event.preventDefault();


        if (!Staffpassword) {
            Swal.fire({
                icon: "warning",
                title: "Password Required",
                text: "Please enter a password for staff login",
            });
            return;
        }

        if (Staffpassword.length < 6) {
            Swal.fire({
                icon: "warning",
                title: "Weak Password",
                text: "Password must be at least 6 characters long",
            });
            return;
        }

        if (Staffpassword !== ConfirmPassword) {
            Swal.fire({
                icon: "error",
                title: "Password Mismatch",
                text: "Password and Confirm Password do not match",
            });
            return;
        }

        const staff_area = selectedAreas.length > 0 ? selectedAreas.join(',') : null;

        const data = {
            staff_name: Staffname,
            staff_spouse: Staffspousename,
            staff_father: Stafffathername,
            staff_code: StaffCode,
            staff_street: Staffstreet,
            staff_dob: Staffdob,
            staff_gender: Staffgender,
            staff_place: Staffplace,
            staff_district: Staffdistrict,
            staff_state: Staffstate,
            staff_cntry: Staffcountry,
            staff_pin: Staffpincode,
            staff_email: Staffemail,
            staff_brief: Staffbriefnote,
            staff_mobile: Staffmobile,
            staff_phone: Staffphone || null,
            staff_area: staff_area,
            staff_region: primaryRegionId,
            staff_pass: Staffpassword,   // ✅ sent to backend
            staff_username: Staffusername,
            userid: accessuserid
        };

        fetch(baseurladdress + "staff/addstaff", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result.status === "Success") {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "success",
                        title: "Staff added successfully",
                        showConfirmButton: false,
                        timer: 1800,
                    });
                    navigate("/staff");
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Failed",
                        text: result.message || "Unable to add staff",
                    });
                }
            })
            .catch((error) => {
                Swal.fire({
                    icon: "error",
                    title: "Server Error",
                    text: error.message,
                });
            });
    };

    // Load Regional Managers on component mount
    useEffect(() => {
        axios
            .get(baseurladdress + "region/regional-managers", {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    setRegionalManagers(res.data.managers);
                } else {
                    setRegionalManagers([]);
                }
            })
            .catch((error) => {
                console.error("Failed to load regional managers:", error);
                setRegionalManagers([]);
            });
    }, []);

    // When Regional Manager is selected, load Area Managers under that Regional Manager
    useEffect(() => {
        if (selectedRegionalManager) {
            axios
                .get(baseurladdress + `staff/getareamanagersbyregionalmanager/${selectedRegionalManager}`, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then((res) => {
                    if (res.data.status === "Success") {
                        setAreaManagers(res.data.managers);
                    } else {
                        setAreaManagers([]);
                    }
                })
                .catch((error) => {
                    console.error("Failed to load area managers:", error);
                    setAreaManagers([]);
                });

            // Reset area manager and areas when regional manager changes
            setSelectedAreaManager("");
            setAvailableAreas([]);
            setSelectedAreas([]);
        } else {
            setAreaManagers([]);
            setSelectedAreaManager("");
            setAvailableAreas([]);
            setSelectedAreas([]);
        }
    }, [selectedRegionalManager]);

    // When Area Manager is selected, load areas under that Area Manager
    useEffect(() => {
        if (selectedAreaManager) {
            axios
                .get(baseurladdress + `staff/getareasbyareamanager/${selectedAreaManager}`, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then((res) => {
                    if (res.data.status === "Success") {
                        setAvailableAreas(res.data.areas);
                        // Set primary region from first area
                        if (res.data.areas.length > 0) {
                            setPrimaryRegionId(res.data.areas[0].aregion_id);
                        }
                    } else {
                        setAvailableAreas([]);
                    }
                })
                .catch((error) => {
                    console.error("Failed to load areas:", error);
                    setAvailableAreas([]);
                });

            // Reset selected areas when area manager changes
            setSelectedAreas([]);
        } else {
            setAvailableAreas([]);
            setSelectedAreas([]);
            setPrimaryRegionId(null);
        }
    }, [selectedAreaManager]);

    // Load countries
    useEffect(() => {
        axios
            .get(baseurladdress + "staff/getallcountry", {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    const options = res.data.countries.map((item) => (
                        <option key={item.cntry_id} value={item.cntry_id}>
                            {item.cntry_name}
                        </option>
                    ));
                    setcntry_name(options);
                } else {
                    setcntry_name([]);
                }
            })
            .catch((error) => {
                console.error(error);
                alert("Failed to load countries");
            });
    }, []);

    const changeTitle = (staffcntry) => {
        axios
            .get(baseurladdress + "staff/getstates/" + staffcntry, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    const options = res.data.states.map((item) => (
                        <option key={item.state_id} value={item.state_id}>
                            {item.state_name}
                        </option>
                    ));
                    setstate_name(options);
                } else {
                    setstate_name([]);
                }
            })
            .catch((error) => {
                console.error(error);
                alert("Failed to load states");
            });
    };

    const changeDistricts = (staffdistrict) => {
        axios
            .get(baseurladdress + "staff/getdistricts/" + staffdistrict, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    const options = res.data.districts.map((item) => (
                        <option key={item.district_id} value={item.district_id}>
                            {item.district_name}
                        </option>
                    ));
                    setdistrict_name(options);
                } else {
                    setdistrict_name([]);
                }
            })
            .catch((error) => {
                console.error(error);
                alert("Failed to load districts");
            });
    };

    const handleAreaToggle = (areaId) => {
        setSelectedAreas(prev => {
            if (prev.includes(areaId)) {
                return prev.filter(id => id !== areaId);
            } else {
                return [...prev, areaId];
            }
        });
    };

    const handleSelectAll = () => {
        if (selectedAreas.length === availableAreas.length) {
            setSelectedAreas([]);
        } else {
            setSelectedAreas(availableAreas.map(area => area.area_id));
        }
    };

    return (
        <div className="staff-page">
            <div className="staff-container">
                <div className="staff-header">
                    <NavLink to="/staff">
                        <div className="float">
                            <i className="fa fa-arrow-left my-float"></i>
                        </div>
                    </NavLink>
                </div>

                <form onSubmit={handleSubmit} className="staff-form">
                    <div className="staff-columns">

                        {/* LEFT COLUMN */}
                        <div className="staff-column">
                            <div className="staff-card">
                                <div className="staff-card-body">
                                    <div className="card-header">
                                        <h4 className="card-title">ADD STAFF</h4>
                                        <div className="staff-heading-divider"></div>
                                    </div>

                                    <div className="staff-fields">
                                        <div className="staff-group">
                                            <label>Staff Name <span className="staff-required">*</span></label>
                                            <input type="text" placeholder="Staff Name" onChange={(e) => setStaffname(e.target.value)} required />
                                        </div>
                                        <div className="staff-group">
                                            <label>Staff Code <span className="staff-required">*</span></label>
                                            <input type="text" placeholder="Staff Code" onChange={(e) => setStaffCode(e.target.value)} required />
                                        </div>
                                        <div className="staff-group">
                                            <label>Username <span className="staff-required">*</span></label>
                                            <input type="text" placeholder="Username" onChange={(e) => setStaffusername(e.target.value)} required />
                                        </div>
                                        <div className="staff-group">
                                            <label>DOB <span className="staff-required">*</span></label>
                                            <input type="date" onChange={(e) => setStaffdob(e.target.value)} required />
                                        </div>
                                        <div className="staff-group">
                                            <label>Gender</label>
                                            <select onChange={(e) => setStaffgender(e.target.value)}>
                                                <option value="" disabled selected>Select</option>
                                                <option value="1">Male</option>
                                                <option value="2">Female</option>
                                                <option value="3">Other</option>
                                            </select>
                                        </div>
                                        <div className="staff-group">
                                            <label>Mobile <span className="staff-required">*</span></label>
                                            <input type="tel" placeholder="Mobile Number" pattern="[0-9]+" minLength="10" maxLength="14" onChange={(e) => setStaffmobile(e.target.value)} required />
                                        </div>
                                        <div className="staff-group">
                                            <label>Phone</label>
                                            <input type="tel" placeholder="Contact Number" pattern="[0-9]+" minLength="10" maxLength="14" onChange={(e) => setStaffphone(e.target.value)} />
                                        </div>
                                        <div className="staff-group">
                                            <label>Email <span className="staff-required">*</span></label>
                                            <input type="email" placeholder="Email ID" pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$" onChange={(e) => setStaffemail(e.target.value)} required />
                                        </div>
                                        <div className="staff-group">
                                            <label className="staff-label-normal">Brief</label>
                                            <textarea placeholder="Brief" onChange={(e) => setStaffbriefnote(e.target.value)}></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT COLUMN */}
                        <div className="staff-column">
                            <div className="staff-card">
                                <div className="staff-card-body">
                                    <div className="staff-fields">
                                        <div className="staff-group">
                                            <label>Father Name</label>
                                            <input type="text" placeholder="Father Name" onChange={(e) => setStafffathername(e.target.value)} />
                                        </div>
                                        <div className="staff-group">
                                            <label>Spouse Name</label>
                                            <input type="text" placeholder="Husband / Wife Name" onChange={(e) => setStaffspousename(e.target.value)} />
                                        </div>
                                        <div className="staff-group">
                                            <label>Street <span className="staff-required">*</span></label>
                                            <input type="text" placeholder="Street" onChange={(e) => setStaffstreet(e.target.value)} required />
                                        </div>
                                        <div className="staff-group">
                                            <label>Place <span className="staff-required">*</span></label>
                                            <input type="text" placeholder="Place" onChange={(e) => setStaffplace(e.target.value)} required />
                                        </div>
                                        <div className="staff-group">
                                            <label>Pin <span className="staff-required">*</span></label>
                                            <input type="text" pattern="[0-9]+" minLength="6" maxLength="6" placeholder="Pin" onChange={(e) => setStaffpincode(e.target.value)} required />
                                        </div>
                                        <div className="staff-group">
                                            <h6><span style={{ color: "red" }}>*</span>Country</h6>
                                            <select
                                                className="form-control select"
                                                name="Country"
                                                onChange={e => { changeTitle(e.target.value); setStaffcountry(e.target.value) }}
                                            >
                                                <option value="" disabled selected>Select</option>
                                                {cntry_name}
                                            </select>
                                        </div>
                                        <div className="staff-group">
                                            <h6><span style={{ color: "red" }}>*</span>State</h6>
                                            <select
                                                className="form-control select"
                                                name="State"
                                                onChange={e => { changeDistricts(e.target.value); setStaffstate(e.target.value) }}
                                            >
                                                <option value="" disabled selected>Select</option>
                                                {state_name}
                                            </select>
                                        </div>
                                        <div className="staff-group">
                                            <h6><span style={{ color: "red" }}>*</span>District</h6>
                                            <select
                                                className="form-control select"
                                                name="District"
                                                onChange={(e) => setStaffdistrict(e.target.value)}
                                            >
                                                <option value="" disabled selected>Select</option>
                                                {district_name}
                                            </select>
                                        </div>
                                        <div className="staff-group">
                                            <label>Password <span className="staff-required">*</span></label>
                                            <div style={{ position: "relative" }}>
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Enter Password"
                                                    minLength="6"
                                                    onChange={(e) => setStaffpassword(e.target.value)}
                                                    required
                                                    style={{ paddingRight: "40px", width: "100%" }}
                                                />
                                                <i
                                                    className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                                                    onClick={() => setShowPassword(prev => !prev)}
                                                    style={{
                                                        position: "absolute",
                                                        right: "12px",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        cursor: "pointer",
                                                        color: "#888",
                                                        fontSize: "16px"
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="staff-group">
                                            <label>Confirm Password <span className="staff-required">*</span></label>
                                            <div style={{ position: "relative" }}>
                                                <input
                                                    type={showConfirmPassword ? "text" : "password"}
                                                    placeholder="Confirm Password"
                                                    minLength="6"
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                    required
                                                    style={{ paddingRight: "40px", width: "100%" }}
                                                />
                                                <i
                                                    className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}
                                                    onClick={() => setShowConfirmPassword(prev => !prev)}
                                                    style={{
                                                        position: "absolute",
                                                        right: "12px",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        cursor: "pointer",
                                                        color: "#888",
                                                        fontSize: "16px"
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        {/* Regional Manager Dropdown */}
                                        <div className="staff-group">
                                            <label>Regional Manager <span className="staff-required">*</span></label>
                                            <select
                                                className="form-control select"
                                                value={selectedRegionalManager}
                                                onChange={(e) => setSelectedRegionalManager(e.target.value)}
                                                required
                                            >
                                                <option value="" disabled>Select Regional Manager</option>
                                                {regionalManagers.map((manager) => (
                                                    <option key={manager.user_id} value={manager.user_id}>
                                                        {manager.user_staffname}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Area Manager Dropdown */}
                                        <div className="staff-group">
                                            <label>Area Manager <span className="staff-required">*</span></label>
                                            <select
                                                className="form-control select"
                                                value={selectedAreaManager}
                                                onChange={(e) => setSelectedAreaManager(e.target.value)}
                                                disabled={!selectedRegionalManager}
                                                required
                                            >
                                                <option value="" disabled>
                                                    {selectedRegionalManager ? "Select Area Manager" : "Select Regional Manager First"}
                                                </option>
                                                {areaManagers.map((manager) => (
                                                    <option key={manager.user_id} value={manager.user_id}>
                                                        {manager.user_staffname}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Assign Areas button */}
                                        <div className="staff-group-full" style={{ marginTop: '15px' }}>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (!selectedAreaManager) {
                                                        Swal.fire({
                                                            icon: "warning",
                                                            title: "Selection Required",
                                                            text: "Please select an Area Manager first",
                                                        });
                                                        return;
                                                    }
                                                    setShowAreaModal(true);
                                                }}
                                                disabled={!selectedAreaManager}
                                                style={{
                                                    width: '100%',
                                                    padding: '12px 20px',
                                                    backgroundColor: selectedAreaManager ? '#28a745' : '#cccccc',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    cursor: selectedAreaManager ? 'pointer' : 'not-allowed',
                                                    fontSize: '15px',
                                                    fontWeight: '500',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '8px'
                                                }}
                                            >
                                                <i className="fa fa-map-marker"></i>
                                                Assign Areas ({selectedAreas.length} selected)
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="staff-btn-container">
                        <button type="submit" className="staff-btn">Submit</button>
                    </div>
                </form>
            </div>

            {/* AREA ASSIGNMENT MODAL */}
            {showAreaModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        width: '90%',
                        maxWidth: '600px',
                        maxHeight: '85vh',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            padding: '20px',
                            borderBottom: '1px solid #e0e0e0',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                                Select Areas
                            </h3>
                            <button
                                onClick={() => setShowAreaModal(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#666',
                                    padding: '0',
                                    width: '30px',
                                    height: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {/* Modal Body */}
                        <div style={{
                            padding: '20px',
                            flex: 1,
                            overflowY: 'auto'
                        }}>
                            {/* Select All Button */}
                            <div style={{
                                marginBottom: '15px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                paddingBottom: '15px',
                                borderBottom: '2px solid #e0e0e0'
                            }}>
                                <button
                                    type="button"
                                    onClick={handleSelectAll}
                                    style={{
                                        padding: '8px 16px',
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500'
                                    }}
                                >
                                    {selectedAreas.length === availableAreas.length ? 'Deselect All' : 'Select All'}
                                </button>
                                <span style={{ color: '#666', fontSize: '14px', fontWeight: '500' }}>
                                    {selectedAreas.length} of {availableAreas.length} areas selected
                                </span>
                            </div>

                            {/* Areas List */}
                            {availableAreas.length === 0 ? (
                                <p style={{
                                    textAlign: 'center',
                                    color: '#999',
                                    padding: '40px 20px',
                                    margin: 0
                                }}>
                                    No areas available for this Area Manager
                                </p>
                            ) : (
                                <div>
                                    {availableAreas.map((area, index) => (
                                        <div
                                            key={area.area_id}
                                            style={{
                                                padding: '12px 15px',
                                                backgroundColor: selectedAreas.includes(area.area_id)
                                                    ? '#e3f2fd'
                                                    : '#fff',
                                                borderBottom: index < availableAreas.length - 1
                                                    ? '1px solid #f0f0f0'
                                                    : 'none',
                                                cursor: 'pointer',
                                                transition: 'background-color 0.2s',
                                                display: 'flex',
                                                alignItems: 'center',
                                                borderRadius: '4px',
                                                marginBottom: '5px'
                                            }}
                                            onClick={() => handleAreaToggle(area.area_id)}
                                            onMouseEnter={(e) => {
                                                if (!selectedAreas.includes(area.area_id)) {
                                                    e.currentTarget.style.backgroundColor = '#f5f5f5';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (!selectedAreas.includes(area.area_id)) {
                                                    e.currentTarget.style.backgroundColor = '#fff';
                                                }
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selectedAreas.includes(area.area_id)}
                                                onChange={(e) => {
                                                    e.stopPropagation();
                                                    handleAreaToggle(area.area_id);
                                                }}
                                                onClick={(e) => e.stopPropagation()}
                                                style={{
                                                    marginRight: '12px',
                                                    cursor: 'pointer',
                                                    width: '18px',
                                                    height: '18px'
                                                }}
                                            />
                                            <span style={{ fontSize: '15px', color: '#333', fontWeight: '500' }}>
                                                {area.area_name}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Modal Footer */}
                        <div style={{
                            padding: '15px 20px',
                            borderTop: '1px solid #e0e0e0',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '10px'
                        }}>
                            <button
                                type="button"
                                onClick={() => setShowAreaModal(false)}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#6c757d',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={() => setShowAreaModal(false)}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#28a745',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}
                            >
                                Done
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}